module.exports = __webpack_public_path__ + "static/media/material-ui-logo.cb2f65a2.svg";